/* Traced cabinet silhouettes in the 1774 x 887 desktop room photographs.
 * Keeping wall reflections outside these outlines prevents paint halos.
 * Interior objects are still excluded by the color/fixture mask. */
window.GCS_CABINET_OUTLINES = {
  classic: [
    [[0,735],[358,660],[400,553],[395,684],[352,887],[0,887]],
    [[462,337],[479,329],[490,356],[491,552],[468,552]],
    [[569,518],[987,568],[987,796],[759,882],[749,846],[568,654]],
    [[741,285],[1238,23],[1306,105],[1306,704],[1242,758],[1130,714],[976,667],[975,584],[741,514]]
  ],
  modern: [
    [[422,156],[673,189],[673,458],[583,470],[581,289],[444,286],[444,587],[423,590]],
    [[785,213],[1093,135],[1125,143],[1275,106],[1275,89],[1453,39],[1453,683],[1278,642],[1278,634],[1236,624],[1236,507],[1068,490],[1068,461],[946,445],[946,475],[784,459]],
    [[504,484],[927,562],[927,777],[845,749],[549,639]]
  ],
  bathroom: [
    [[479,491],[1171,491],[1171,658],[479,658]]
  ],
  wetbar: [
    [[443,62],[450,44],[704,44],[714,65],[1061,65],[1072,44],[1325,44],[1333,63],[1331,526],[1293,517],[1293,428],[1070,428],[1070,367],[695,367],[695,428],[482,428],[482,517],[444,527]],
    [[432,543],[1345,543],[1342,715],[1334,719],[1334,765],[1176,765],[1176,544],[1000,544],[1000,765],[441,765],[441,733],[433,713]]
  ],
  entertainment: [
    [[428,82],[1350,82],[1357,96],[1355,414],[422,414],[422,107],[421,96]],
    [[417,426],[1363,426],[1363,562],[418,562]]
  ],
  closet: [
    [[338,0],[555,0],[620,79],[1157,79],[1227,0],[1431,0],[1431,690],[1434,693],[1434,718],[1333,718],[1167,584],[612,584],[452,704],[336,704]],
    [[699,510],[1074,510],[1075,777],[1081,782],[1081,814],[697,813],[697,783]]
  ],
  mudroom: [
    [[403,49],[1337,47],[1333,72],[1331,689],[1329,697],[1329,721],[1174,721],[1174,726],[583,726],[583,721],[411,721],[411,696],[407,686],[407,75]]
  ],
  office: [
    [[400,83],[1305,83],[1305,93],[1317,93],[1313,110],[1313,487],[1320,489],[1320,496],[1315,498],[1315,688],[1050,688],[1050,695],[946,695],[946,669],[743,669],[743,695],[644,695],[644,688],[381,688],[381,663],[377,658],[378,498],[376,490],[391,488],[391,110],[388,94],[400,94]]
  ]
};

// Subpixel scan conversion preserves diagonal edges without pixel stair steps.
window.gcsCabinetBoundary = function (id, w, h, wide = true) {
  const mobile = {
    office: [[[106,84],[1217,84],[1217,96],[1230,99],[1226,122],[1226,644],[1233,645],[1233,653],[1227,657],[1227,931],[909,931],[909,940],[780,940],[780,906],[524,906],[524,938],[396,938],[396,928],[72,928],[72,898],[68,889],[68,655],[66,648],[79,643],[79,121],[77,97],[106,97]]]
  };
  const polygons = (wide ? window.GCS_CABINET_OUTLINES : mobile)[id];
  if (!polygons) return null;
  const result = new Float32Array(w * h);
  for (const polygon of polygons) {
    const points = polygon.map(([x, y]) => [x * w / (wide ? 1774 : 1254), y * h / (wide ? 887 : 1254)]);
    for (let y = 0; y < h; y++) {
      for (let sub = 0; sub < 4; sub++) {
        const row = y + (sub + .5) / 4, crossings = [];
        for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
          const a = points[i], b = points[j];
          if ((a[1] > row) !== (b[1] > row)) crossings.push(a[0] + (row - a[1]) * (b[0] - a[0]) / (b[1] - a[1]));
        }
        crossings.sort((a, b) => a - b);
        for (let i = 0; i + 1 < crossings.length; i += 2) {
          const left = Math.max(0, crossings[i]), right = Math.min(w, crossings[i + 1]);
          for (let x = Math.floor(left); x < Math.ceil(right); x++) {
            const n = y * w + x;
            result[n] = Math.min(1, result[n] + Math.max(0, Math.min(x + 1, right) - Math.max(x, left)) / 4);
          }
        }
      }
    }
  }
  return result;
};
